export default __webpack_public_path__ + "static/media/logo.f2c9dc0f.png";